var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('request',{attrs:{"request":_vm.request},on:{"on-success":_vm.setData}},[_c('product-analytics-report-table',{attrs:{"reports":_vm.reports}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }